import React from 'react';

import {ButtonStyled} from './Button.styled';

const SuccessButton = (props) => {
    return <>
        <ButtonStyled 
            success={props.success}
            danger={props.danger}
            onClick={props.onClick}
        >{props.text}</ButtonStyled>
    </>
}

export default SuccessButton;